import { defAction } from "../../../../helpers/defaultAction"
import { reRegionConstants } from "./constants"
import api from './api'

export const reRegionActions = {
	getList,
	clear,
	getListForRoles
}

function getList(values){
	const dispatchObj = {
		constants : reRegionConstants.GetList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getListForRoles(values){
	const dispatchObj = {
		constants : reRegionConstants.GetListForRoles,
		service   : {
			func   : api.getListForRoles,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: reRegionConstants.CLEAR
	})
}